import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { PickController } from "./PickController";
import { Spot } from "./Spot";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { Symbol } from "../Symbol";
import { WinAnimator2 } from "../../CustomComponents/WinAnimator2";
import { ModuleManager } from "../../Managers/ModuleManager";
import { ImageTextCounterElement } from "../../Components/Elements/Texts/ImageTextCounterElement";
import { CustomUtils } from "../../Utils/CustomUtils";
import { AnimationElement } from "../../Components/Elements/Graphics/AnimationElement";
import { BaseView } from "../Base/BaseView";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { LayoutManager } from "../../Managers/LayoutManager";
import { LayoutSwitchElement } from "../../CustomComponents/LayoutSwitchElement";

@engineComponent(ComponentTypes.DisplayObject)
export class PickView extends LayoutSwitchElement {
    public static LayoutManager: LayoutManager;

    public static ActualValue: number = 0;
    public static ActualValueType: string = "";

    public static Counters: SwitchElement;

    private _controller: PickController;

    private _spots: Array<Spot> = [];
    private _bottomContainer: ContainerElement;
    private _topContainer: ContainerElement;
    private _transition: SwitchElement;

    private _statusTimer: FrameTimerEventEmitter;
    private _status: string;

    private _actualReel: number = -1;
    private _actualValue: number = -1;
    private _actualValueType: string = "";
    private _pickSelected: number = 0;

    private _outroDelay: FrameTimerEventEmitter;

    constructor() {
        super();

        this._statusTimer = CreateFrameTimer("statusTimer");
        this._statusTimer.on(FrameTimerEvents.Complete, this.statusTimerComplete.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        this._bottomContainer = this.getChildElementByName("BottomContainer") as ContainerElement;
        this._topContainer = this.getChildElementByName("TopContainer") as ContainerElement;
        this._topContainer = this.getChildElementByName("TopContainer") as ContainerElement;
        this._transition = this.getChildElementByName("Transition") as SwitchElement;
        PickView.Counters = this.getChildElementByName("Counters") as SwitchElement;

        let spots = this.getChildElementByName("Spots") as ContainerElement;
        let i: number;
        for (i = 0; i < 15; i++) {
            if (spots.childs["Spot_" + i] != null) {
                this._spots.push(spots.childs["Spot_" + i]);
            }
        }

        this.resetChildren();
    }

    private resetChildren() {
        let i: number;
        if (this._spots != null) {
            this._topContainer.alpha = 1;
            this._bottomContainer.alpha = 1;
            for (i = 0; i < this._spots.length; i++) {
                if (this._bottomContainer != null) {
                    this._bottomContainer.addChild(this._spots[i]);
                }
                this._spots[i].goToCase("HIDE");
                this._spots[i].visible = true;
                this._spots[i].alpha = 1;
                this._spots[i].enabled = false;
            }
        }
    }

    private statusTimerComplete(): void {
        switch (this._status) {
            case "start":
                this.introFinished();
                break;
            case "selectUpdate":
                this.updateCounterValues();
                break;
            case "select":
                this.enabledSpots();
                this._controller.selectComplete();
                break;
            case "updateCounters":
                this.updateCounters();
                break;
            case "showWin":
                this.showWin();
                break;
        }
    }

    disableLogo(): void {
        /*if (this.childs['Logo'] != null) {
            this.removeChild(this.childs['Logo']);
        }*/
    }

    initReceived(controller: PickController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;
    }

    initIntro(): void {
        this._pickSelected = 0;
        this.resetChildren();
        this.resetSymbols();

        this.goToCase("PICK_INIT");
        if (BaseView.Logo != null && BaseView.Logo.getCurrentCase() !== "PICK_INIT") {
            BaseView.Logo.goToCase("PICK_INIT");
        }

        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            if (ModuleManager.freespinsEnabled()) {
                PlayList.loop("SND_FSloop");
            } else {
                PlayList.loop("SND_FSpickupMusic");
            }

            this.visible = true;

            let i: number = 0;
            for (let key in GameManager.pickResponse.round.spots) {
                let id: number = GameManager.pickResponse.round.spots[key].id;
                let status: string = GameManager.pickResponse.round.spots[key].status.toString();
                let addDelay: boolean = true;
                let value: number = null;
                let valueType: string = null;
                if (GameManager.pickResponse.round.spots[key].value != null) {
                    value = parseInt(GameManager.pickResponse.round.spots[key].value + "");
                }

                if (GameManager.pickResponse.round.spots[key].valueType != null) {
                    valueType = GameManager.pickResponse.round.spots[key].valueType.toString();
                }

                if (id != null && status != null) {
                    if (this._spots != null && this._spots[id] != null) {
                        let symbol: Symbol = this.getSymbolFromBaseGame(id);
                        switch (status) {
                            case "enabled":
                                if (symbol != null) {
                                    addDelay = false;
                                    symbol.visible = false;
                                    this._spots[id].goToCase("START_NOW");
                                }

                                this._spots[id].enabled = true;
                                break;
                            case "disabled":
                                if (symbol != null) {
                                    addDelay = false;
                                    symbol.visible = false;
                                    this._spots[id].goToCase("START_NOW");
                                }
                                break;
                            case "revealed":
                                this._pickSelected++;
                                if (symbol != null) {
                                    addDelay = false;
                                    symbol.visible = false;
                                    this._spots[id].enabled = false;
                                    if (value != null && valueType != null) {
                                        this._actualValue = value;
                                        PickView.ActualValue = value;
                                        this._actualValueType = valueType;
                                        PickView.ActualValueType = valueType;

                                        if (this._topContainer != null) {
                                            this._topContainer.addChild(this._spots[id]);
                                        }

                                        if (valueType === "count") {
                                            this._spots[id].updateFSValue(value.toString());
                                            this._spots[id].goToCase("REVEALED_FS_WIN");
                                        } else if (valueType === "multiplier") {
                                            this._spots[id].updateMPValue("x" + value.toString());
                                            this._spots[id].goToCase("REVEALED_MLP_WIN");
                                        }
                                    }
                                }
                                break;
                            case "shown":
                                if (symbol != null) {
                                    addDelay = false;
                                    symbol.visible = false;
                                    this._spots[id].enabled = false;
                                    if (value != null && valueType != null) {
                                        this._spots[id].goToCase("DISABLED");
                                        if (valueType === "count") {
                                            this._spots[id].updateFSValue(value.toString());
                                            this._spots[id].goToCase("SHOWN_FS_WIN");
                                        } else if (valueType === "multiplier") {
                                            this._spots[id].updateMPValue("x" + value.toString());
                                            this._spots[id].goToCase("SHOWN_MLP_WIN");
                                        }
                                    }
                                }
                                break;
                        }
                    }
                }
                if (addDelay) {
                    i++;
                }
            }

            this._status = "select";
            this._statusTimer.start(1);

            this.initializeCounters();
        }
    }

    private initializeCounters(intro: boolean = false): void {
        if (PickView.Counters != null && GameManager.pickResponse != null) {
            this.updateCounterValue(
                <SwitchElement>PickView.Counters.getChildElementByName("FSCounter"),
                GameManager.pickResponse.count,
            );
            this.updateCounterValue(
                <SwitchElement>PickView.Counters.getChildElementByName("MLPCounter"),
                GameManager.pickResponse.multiplier,
            );

            PickView.Counters.goToCase(intro ? "SHOW" : "NORMAL");
        }
    }

    private updateCounters(): void {
        this._controller.updateCounters();

        this._status = "selectUpdate";
        this._statusTimer.start(60);
    }

    private updateCounterValues(): void {
        if (PickView.Counters != null && GameManager.pickResponse != null) {
            if (this._actualValueType != null) {
                if (this._actualValueType === "count") {
                    PlayList.play("SND_PickupAdd01");
                } else if (this._actualValueType === "multiplier") {
                    PlayList.play("SND_PickupAdd02");
                }
            }
            this.updateCounterValue(
                <SwitchElement>PickView.Counters.getChildElementByName("FSCounter"),
                GameManager.pickResponse.count,
            );
            this.updateCounterValue(
                <SwitchElement>PickView.Counters.getChildElementByName("MLPCounter"),
                GameManager.pickResponse.multiplier,
            );

            PickView.Counters.goToCase(this._actualValueType == "count" ? "POP_FS" : "POP_MP");
        }
        this._actualReel = -1;
        this._actualValue = -1;
        PickView.ActualValue = -1;
        this._actualValueType = "";
        PickView.ActualValueType = "";

        this._status = "select";
        this._statusTimer.start(20);
    }

    private updateCounterValue(counterHolder: SwitchElement, value: number): void {
        if (counterHolder != null) {
            let counterElement = <ImageTextCounterElement>counterHolder.getChildElementByName("Counter");
            if (counterElement != null) {
                counterElement.setBitmapText(value);
            }
        }
    }

    collect(): void {}

    start(): void {}

    select(): void {}

    end(): void {}

    startReceived(): void {}

    selectReceived(): void {
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            let i: number = 0;
            for (let key in GameManager.pickResponse.round.spots) {
                let id: number = GameManager.pickResponse.round.spots[key].id;
                let status: string = GameManager.pickResponse.round.spots[key].status.toString();

                let value: number = null;
                let valueType: string = null;

                if (GameManager.pickResponse.round.spots[key].value != null) {
                    value = parseInt(GameManager.pickResponse.round.spots[key].value + "");
                }

                if (GameManager.pickResponse.round.spots[key].valueType != null) {
                    valueType = GameManager.pickResponse.round.spots[key].valueType.toString();
                }

                if (id != null && status != null) {
                    if (this._spots != null && this._spots[id] != null) {
                        switch (status) {
                            case "revealed":
                                this._pickSelected++;
                                if (this._spots[id].enabled) {
                                    this._spots[id].enabled = false;
                                    if (value != null && valueType != null) {
                                        this._actualValue = value;
                                        PickView.ActualValue = value;
                                        this._actualValueType = valueType;
                                        PickView.ActualValueType = valueType;

                                        if (this._topContainer != null) {
                                            this._topContainer.addChild(this._spots[id]);
                                        }

                                        PlayList.play("SND_FSpickupDraw");

                                        if (valueType === "count") {
                                            this._spots[id].updateFSValue(value.toString());
                                            this._spots[id].goToCase("REVEALED_FS");
                                            PlayList.play("SND_PickupPick01");
                                        } else if (valueType === "multiplier") {
                                            this._spots[id].updateMPValue("x" + value.toString());
                                            this._spots[id].goToCase("REVEALED_MLP");
                                            PlayList.play("SND_PickupPick02");
                                        }
                                    }
                                }
                                break;
                            case "shown":
                                if (this._spots[id].enabled) {
                                    this._spots[id].enabled = false;
                                    if (value != null && valueType != null) {
                                        this._spots[id].goToCase("DISABLED");
                                        if (valueType === "count") {
                                            this._spots[id].updateFSValue(value.toString());
                                            this._spots[id].delayedGoToCase(60, "SHOWN_FS");
                                        } else if (valueType === "multiplier") {
                                            this._spots[id].updateMPValue("x" + value.toString());
                                            this._spots[id].delayedGoToCase(60, "SHOWN_MLP");
                                        }
                                    }
                                }
                                break;
                        }
                    }
                }
                i++;
            }

            this._status = "showWin";
            this._statusTimer.start(30);
        }
    }

    showWin(): void {
        this._status = "updateCounters";
        this._statusTimer.start(30);
    }

    endReceived(): void {
        PlayList.play("SND_FSTrans");
        PlayList.stop("SND_FSpickupMusic");
        PlayList.loop("SND_FSloop");
    }

    intro(long: boolean = false): void {
        this.resetSpots();

        this.goToCase("PICK_INIT");
        if (BaseView.Logo != null && BaseView.Logo.getCurrentCase() !== "PICK_INIT") {
            BaseView.Logo.goToCase("PICK_INIT");
        }

        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            PlayList.stop("SND_FSWinLoop");
            PlayList.loop("SND_FSpickupMusic");

            this.visible = true;

            let i: number = 0;
            const animDelay = WinAnimator2.OutroToPickDelay;
            const animDuration = 30;
            for (let key in GameManager.pickResponse.round.spots) {
                let id: number = GameManager.pickResponse.round.spots[key].id;
                let status: string = GameManager.pickResponse.round.spots[key].status.toString();

                if (id != null && status != null) {
                    if (this._spots != null && this._spots[id] != null) {
                        let symbol: Symbol = this.getSymbolFromBaseGame(id);
                        let reel = Math.floor(id / 3);
                        switch (status) {
                            case "enabled":
                                this._spots[id].setDynamicTime(reel * animDelay);
                                this._topContainer.addChild(this._spots[id]);

                                if (symbol.id + 1 == CustomUtils.SymbolScatter) {
                                    const frame = this.getDiamondCurrentFrame(symbol);
                                    this._spots[id].setAnimationFrame(frame);
                                    this._spots[id].goToCase("START_VISIBLE");
                                    i++;
                                } else {
                                    this._spots[id].goToCase("START");
                                }
                                this._spots[id].enabled = true;
                                break;
                            case "disabled":
                                this._spots[id].setDynamicTime(reel * animDelay);
                                this._bottomContainer.addChild(this._spots[id]);

                                if (symbol.id + 1 == CustomUtils.SymbolScatter) {
                                    const frame = this.getDiamondCurrentFrame(symbol);
                                    this._spots[id].setAnimationFrame(frame);
                                    this._spots[id].goToCase("START_VISIBLE");
                                    i++;
                                } else {
                                    this._spots[id].goToCase("START");
                                }
                                break;
                        }
                    }
                }
            }

            this._status = "start";
            this._statusTimer.start(i * animDelay + animDuration);

            this.initializeCounters(true);
        }
    }

    private resetSpots(): void {
        for (let i = 0; i < this._spots.length; i++) {
            this._spots[i].goToCase("EMPTY");
            this._spots[i].enabled = false;
        }
    }

    private getDiamondCurrentFrame(symbol: Symbol): number {
        if (symbol != null) {
            const holder = <SwitchElement>symbol.getChildElementByName("Diamond");
            if (holder != null) {
                const elem = <AnimationElement>holder.getChildElementByName("Normal");
                return elem.getCurrentFrame();
            }
        }

        return -1;
    }

    enabledSpots(): void {
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            let i = 0;
            for (let key in GameManager.pickResponse.round.spots) {
                let id: number = GameManager.pickResponse.round.spots[key].id;
                let status: string = GameManager.pickResponse.round.spots[key].status.toString();
                let reel = Math.floor(id / 3);

                if (id != null && status != null) {
                    if (this._spots != null && this._spots[id] != null) {
                        switch (status) {
                            case "enabled":
                                this._spots[id].enabled = true;
                                this._spots[id].changeState(true);
                                this._spots[id].goToCase("ENABLED");
                                this._topContainer.addChild(this._spots[id]);
                                break;
                            case "disabled":
                                if (this._spots[id].getCurrentCase() != "DISABLED") {
                                    this._spots[id].setDynamicTime(i * 2);
                                    i++;
                                    this._spots[id].goToCase("DISABLED_DELAYED");
                                }
                                this._bottomContainer.addChild(this._spots[id]);
                                break;
                        }
                    }
                }
            }
        }
    }

    getSymbolFromBaseGame(id: number): Symbol {
        if (WinAnimator2.Symbols != null) {
            switch (id) {
                case 0:
                    return WinAnimator2.Symbols[0][0];
                case 1:
                    return WinAnimator2.Symbols[0][1];
                case 2:
                    return WinAnimator2.Symbols[0][2];
                case 3:
                    return WinAnimator2.Symbols[1][0];
                case 4:
                    return WinAnimator2.Symbols[1][1];
                case 5:
                    return WinAnimator2.Symbols[1][2];
                case 6:
                    return WinAnimator2.Symbols[2][0];
                case 7:
                    return WinAnimator2.Symbols[2][1];
                case 8:
                    return WinAnimator2.Symbols[2][2];
                case 9:
                    return WinAnimator2.Symbols[3][0];
                case 10:
                    return WinAnimator2.Symbols[3][1];
                case 11:
                    return WinAnimator2.Symbols[3][2];
                case 12:
                    return WinAnimator2.Symbols[4][0];
                case 13:
                    return WinAnimator2.Symbols[4][1];
                case 14:
                    return WinAnimator2.Symbols[4][2];
            }
        }
        return null;
    }

    private resetSymbols(): void {
        for (let i = 0; i < 15; i++) {
            const symbol = this.getSymbolFromBaseGame(i);

            if (symbol != null) {
                symbol.goToCase(Symbol.CaseNowin);
            }
        }
    }

    introFinished(): void {
        this.enabledSpots();
        this._controller.introFinished();
    }

    outro(): void {
        if (this._transition != null) {
            PlayList.play("SND_FSTransition");
            this._transition.goToCase("START");
        }

        (this.getChildElementByName("TransitionHolder") as ContainerElement).addChild(BaseView.Transition);
        BaseView.Transition.setDynamicTime(60);
        BaseView.Transition.goToCase("START");
        this._outroDelay.start(180);
    }

    outroFinished(): void {
        this.visible = false;
        this._controller.outroFinished();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Pick/PickView.ts
 **/